export enum AccountState {
  CHATS_BLOCKED = 'CHATS_BLOCKED',
  PERMANENT_BAN = 'PERMANENT_BAN',
}

const normalizeAccountState = (accountState?: string | null): string | undefined =>
  accountState?.toUpperCase();

interface AccountBlockState {
  accountState?: string | null;
  enable?: boolean;
  banEndedAt?: string | null;
}

export const isChatsBlockedAccountState = (accountState?: string | null): boolean =>
  normalizeAccountState(accountState) === AccountState.CHATS_BLOCKED;

export const isPermanentBanAccountState = (accountState?: string | null): boolean =>
  normalizeAccountState(accountState) === AccountState.PERMANENT_BAN;

export const isPermanentBanAccount = ({
  accountState,
  enable,
  banEndedAt,
}: AccountBlockState): boolean =>
  isPermanentBanAccountState(accountState) || (enable === false && !banEndedAt);

export const shouldShowChatsBlockedAccountState = ({
  accountState,
  enable,
  banEndedAt,
}: AccountBlockState): boolean =>
  isChatsBlockedAccountState(accountState) &&
  !isPermanentBanAccount({ accountState, enable, banEndedAt });
